import { render, staticRenderFns } from "./AlbumCard.vue?vue&type=template&id=f31e3354&scoped=true&"
import script from "./AlbumCard.vue?vue&type=script&lang=ts&"
export * from "./AlbumCard.vue?vue&type=script&lang=ts&"
import style0 from "./AlbumCard.vue?vue&type=style&index=0&id=f31e3354&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31e3354",
  null
  
)

export default component.exports